import { ISafetyCaseStatusValues } from './safety-case-status-form-types'
import {
  ISafetyCaseStatus,
  ISafetyCaseStatusAddUpsert,
  ISafetyCaseStatusUpdateUpsert,
  IGeoJson,
} from '../../../../interfaces'

export const safetyCaseStatusToSafetyCaseStatusValues = (
  safetyCaseStatus: ISafetyCaseStatus | undefined,
): ISafetyCaseStatusValues | undefined => {
  if (!safetyCaseStatus) {
    return undefined
  }

  return {
    name: safetyCaseStatus?.name,
    description: safetyCaseStatus?.description,
    baseStatus: safetyCaseStatus?.baseStatus,
    // @ts-ignore
    sortOrder: String(safetyCaseStatus?.sortOrder),
    isActive: safetyCaseStatus?.isActive,
  }
}

export const safetyCaseStatusValuesToSafetyCaseStatusAddUpsert = (
  safetyCaseStatusValues: ISafetyCaseStatusValues,
  payload: { airportId: number },
): ISafetyCaseStatusAddUpsert | undefined => {
  if (!safetyCaseStatusValues) {
    return undefined
  }

  return {
    id: 0,
    airportId: payload?.airportId,
    name: safetyCaseStatusValues?.name,
    description: safetyCaseStatusValues?.description,
    baseStatus: safetyCaseStatusValues?.baseStatus,
    sortOrder: safetyCaseStatusValues?.sortOrder || 0,
    isActive: safetyCaseStatusValues?.isActive || false,
  }
}

export const safetyCaseStatusValuesToSafetyCaseStatusUpdateUpsert = (
  safetyCaseStatusValues: ISafetyCaseStatusValues,
  payload: { safetyCaseStatus: ISafetyCaseStatus; geoJson?: IGeoJson },
): ISafetyCaseStatusUpdateUpsert | undefined => {
  if (!safetyCaseStatusValues || !payload?.safetyCaseStatus?.id || !payload?.safetyCaseStatus?.airportId) {
    return undefined
  }

  return {
    id: payload.safetyCaseStatus.id,
    airportId: payload.safetyCaseStatus.airportId,
    name: safetyCaseStatusValues?.name,
    description: safetyCaseStatusValues?.description,
    baseStatus: safetyCaseStatusValues?.baseStatus,
    sortOrder: safetyCaseStatusValues?.sortOrder,
    isActive: safetyCaseStatusValues?.isActive,
  }
}
